(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/bank-id/bank-id-main.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/bank-id/bank-id-main.js');

'use strict';

const _React = React,
  useEffect = _React.useEffect;
const BankIdStart = svs.iam_idp.components.bank_id.BankIdStart;
const _svs$iam_idp$componen = svs.iam_idp.components.shared,
  PollingMobile = _svs$iam_idp$componen.PollingMobile,
  PollingDesktop = _svs$iam_idp$componen.PollingDesktop,
  Loading = _svs$iam_idp$componen.Loading;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const _svs$iam_idp$atoms = svs.iam_idp.atoms,
  isPollingAtom = _svs$iam_idp$atoms.isPollingAtom,
  showLoaderAtom = _svs$iam_idp$atoms.showLoaderAtom,
  loginCompletedAtom = _svs$iam_idp$atoms.loginCompletedAtom,
  activeMethodAtom = _svs$iam_idp$atoms.activeMethodAtom;
const login = svs.iam_idp.utils.Login;
const BankIdMain = _ref => {
  let showQR = _ref.showQR;
  const activeMethod = useAtomValue(activeMethodAtom);
  const isPolling = useAtomValue(isPollingAtom);
  const showLoader = useAtomValue(showLoaderAtom);
  const loginCompleted = useAtomValue(loginCompletedAtom);
  const PollingComponent = showQR ? PollingDesktop : PollingMobile;
  useEffect(() => {
    if (showQR && !loginCompleted) {
      login.start(activeMethod.isFreja, false);
    }
  }, [activeMethod.isFreja, showQR, loginCompleted]);
  if (loginCompleted) {
    return React.createElement(Loading, null);
  }
  if (showQR && isPolling && showLoader) {
    return React.createElement(PollingDesktop, null);
  }
  return (isPolling || showLoader) && !showQR ? React.createElement(PollingComponent, null) : React.createElement(BankIdStart, {
    isNewCustomer: false,
    showQR: showQR
  });
};
svs.iam_idp.components.bank_id.BankIdMain = BankIdMain;

 })(window);